
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertHeaderAggregatedLargeIec as ObiAlertHeaderAggregatedLargeIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-header-aggregated-large-iec.js';
 
 
 

 
 export const ObiAlertHeaderAggregatedLargeIec = createComponent({
   react: React,
   tagName: 'obi-alert-header-aggregated-large-iec',
   elementClass: ObiAlertHeaderAggregatedLargeIecElement,
   events: {
     
   }
  });
 
 